export default __webpack_public_path__ + "static/media/ide3.5d8e53ff.jpg";